(function () {
  'use strict';

  var SS_KEY = 'nb_traffic_source';
  var CURRENT_KEYS = ['traffic-source_first', 'traffic-source_last', 'traffic-source_path'];

  var PATH_MAX_ITEMS = 6;
  var PATH_MAX_CHARS = 100;
  var KEYWORDS_MAX_ITEMS = 5;
  var KEYWORDS_MAX_CHARS = 100;
  var KEYWORD_MAX_CHARS = 30;
  var CAMPAIGN_MAX_CHARS = 32;
  var CHANNEL_MAX_CHARS = 40;

  // utm_source の表記ゆれを畳む
  var UTM_SOURCE_MAP = {
    google: 'google',
    shopify_email: 'email',
    ig: 'instagram',
    instagram: 'instagram',
    socialplus: 'socialplus',
    'chatgpt.com': 'ai',
    openai: 'ai',
    klarna: 'klarna',
    shop_app: 'shop_app'
  };

  var CLICK_IDS = [
    ['gclid', 'google_ads'],
    ['gbraid', 'google_ads'],
    ['wbraid', 'google_ads'],
    ['srsltid', 'google_shopping'],
    ['fbclid', 'facebook'],
    ['msclkid', 'bing_ads'],
    ['yclid', 'yandex'],
    ['ttclid', 'tiktok']
  ];

  var BOT_RE = /bot|crawl|spider|slurp|mediapartners|bing|yandex|baidu|duckduck|facebookexternalhit|embedly|pinterest|slackbot|vkshare|w3c_validator|headless|lighthouse|gtmetrix|pagespeed|ahrefs|semrush|petalbot|applebot|prerender/i;

  function readConfig() {
    var el = document.querySelector('[data-traffic-source-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (_e) { return null; }
  }

  function isBot() {
    if (navigator.webdriver) return true;
    return BOT_RE.test(navigator.userAgent || '');
  }

  // 区切りに使う文字は値から落とす
  function clean(str, max) {
    var value = String(str || '').replace(/[|>]/g, ' ').replace(/\s+/g, ' ').trim();
    // slice はコードユニット単位で、絵文字などのサロゲートペアを割ってしまう
    var chars = Array.from(value);
    return chars.length > max ? chars.slice(0, max).join('') : value;
  }

  function stamp() {
    return new Date().toISOString().slice(0, 16) + 'Z';
  }

  // あふれたら古い方から落とす
  function capList(list, maxItems, maxChars) {
    var capped = list.length > maxItems ? list.slice(list.length - maxItems) : list.slice();
    while (capped.length > 1 && capped.join('>').length > maxChars) capped.shift();
    return capped;
  }

  function channelFromHost(host) {
    if (host.indexOf('instagram.com') !== -1) return 'instagram';
    if (host === 't.co' || /(^|\.)(twitter|x)\.com$/.test(host)) return 'twitter';
    // line は naver より先に見る。jp.naver.line.android が naver に落ちるため
    if (/(^|\.)line\.me$/.test(host) || host.indexOf('naver.line') !== -1) return 'line';
    if (host === 'mail.google.com' || host === 'com.google.android.gm') return 'email';
    if (host.indexOf('mail.yahoo') !== -1) return 'email';
    if (/(^|\.)google\.[a-z.]+$/.test(host) || host.indexOf('com.google.android.googlequicksearchbox') === 0) return 'google_organic';
    if (host.indexOf('yahoo.') !== -1) return 'yahoo_organic';
    if (host.indexOf('naver.') !== -1) return 'naver';
    if (host.indexOf('bing.com') !== -1) return 'bing_organic';
    if (host === 'shop.app' || host === 'shopify.com') return 'shop_app';
    // www の有無で同じ媒体が別チャネルに割れるため揃える
    return 'referral:' + host.replace(/^www\./, '');
  }

  // 判定できないものは記録しない。サイト内検索や絞り込みで枠が埋まるため
  function buildTouch() {
    var referrerHost = '';
    if (document.referrer) {
      try { referrerHost = new URL(document.referrer).hostname; } catch (_e) { referrerHost = ''; }
    }
    // サイト内バナーに utm が付いていても流入ではない。先に落とす
    if (referrerHost === location.hostname) return null;

    var params = new URLSearchParams(location.search);
    var channel = null;

    var utmSource = params.get('utm_source');
    if (utmSource) {
      channel = UTM_SOURCE_MAP[utmSource.toLowerCase()] || 'utm:' + clean(utmSource, CHANNEL_MAX_CHARS);
    }

    if (!channel) {
      for (var i = 0; i < CLICK_IDS.length; i++) {
        if (params.get(CLICK_IDS[i][0])) {
          channel = CLICK_IDS[i][1];
          break;
        }
      }
    }

    if (!channel && referrerHost) {
      channel = clean(channelFromHost(referrerHost), CHANNEL_MAX_CHARS);
    }

    if (!channel) return null;

    return { c: channel, ts: stamp(), cm: clean(params.get('utm_campaign'), CAMPAIGN_MAX_CHARS) };
  }

  function buildKeyword(config) {
    // 部分一致だと /pages/search-guide のようなパスまで拾う
    if (!config.searchUrl || location.pathname.indexOf(config.searchUrl, location.pathname.length - config.searchUrl.length) === -1) return null;
    return clean(new URLSearchParams(location.search).get('q'), KEYWORD_MAX_CHARS) || null;
  }

  function getPending() {
    try {
      var raw = sessionStorage.getItem(SS_KEY);
      if (!raw) return { t: [], k: [] };
      var parsed = JSON.parse(raw);
      return { t: parsed.t || [], k: parsed.k || [] };
    } catch (_e) {
      return { t: [], k: [] };
    }
  }

  function capture(config) {
    var pending = getPending();
    var changed = false;

    var touch = buildTouch();
    if (touch) {
      var prev = pending.t[pending.t.length - 1];
      // 同じチャネルの連続は経路にならない
      if (!prev || prev.c !== touch.c) {
        pending.t.push(touch);
        changed = true;
      }
    }

    var keyword = buildKeyword(config);
    if (keyword && pending.k.indexOf(keyword) === -1) {
      pending.k.push(keyword);
      changed = true;
    }

    if (!changed) return;
    try { sessionStorage.setItem(SS_KEY, JSON.stringify(pending)); } catch (_e) { /* プライベートモード等では諦める */ }
  }

  function mergePath(existing, channels) {
    var path = existing ? existing.split('>') : [];
    channels.forEach(function (c) {
      // 連続重複だけ畳む。一度離れて戻ってきた経路は残す
      if (path[path.length - 1] !== c) path.push(c);
    });
    return capList(path, PATH_MAX_ITEMS, PATH_MAX_CHARS).join('>');
  }

  function mergeKeywords(existing, keywords) {
    var list = existing ? existing.split('>') : [];
    keywords.forEach(function (k) {
      if (list.indexOf(k) === -1) list.push(k);
    });
    return capList(list, KEYWORDS_MAX_ITEMS, KEYWORDS_MAX_CHARS).join('>');
  }

  function formatTouch(touch) {
    return touch.c + '|' + touch.ts + (touch.cm ? '|' + touch.cm : '');
  }

  function buildUpdateData(current, pending) {
    var updateData = {};
    var changed = false;

    if (pending.t.length) {
      if (!current['traffic-source_first']) {
        updateData['traffic-source_first'] = formatTouch(pending.t[0]);
        changed = true;
      }

      // タイムスタンプで比べると同じページでカートを触るたびに書き換わる
      var lastTouch = pending.t[pending.t.length - 1];
      if (lastTouch.c !== (current['traffic-source_last'] || '').split('|')[0]) {
        updateData['traffic-source_last'] = formatTouch(lastTouch);
        changed = true;
      }

      var channels = pending.t.map(function (touch) { return touch.c; });
      var path = mergePath(current['traffic-source_path'], channels);
      if (path !== current['traffic-source_path']) {
        updateData['traffic-source_path'] = path;
        changed = true;
      }
    }

    if (pending.k.length) {
      var keywords = mergeKeywords(current['search-keywords'], pending.k);
      if (keywords !== current['search-keywords']) {
        updateData['search-keywords'] = keywords;
        changed = true;
      }
    }

    if (!changed) return null;

    // 旧仕様の連番キーは残すと新旧が混在して読めなくなる
    Object.keys(current).forEach(function (key) {
      if (key.indexOf('traffic-source_') === 0 && CURRENT_KEYS.indexOf(key) === -1) updateData[key] = '';
    });
    return updateData;
  }

  function clearPending() {
    try { sessionStorage.removeItem(SS_KEY); } catch (_e) { /* プライベートモード等では諦める */ }
  }

  var flushing = false;

  function flush() {
    var config = readConfig();
    if (!config || flushing) return;

    capture(config);
    var pending = getPending();
    if (!pending.t.length && !pending.k.length) return;

    // 現在値は毎回取り直す。Liquid の値は HTML エスケープされていて区切り文字が壊れる
    flushing = true;
    fetch(config.cartUrl + '.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var updateData = buildUpdateData(cart.attributes || {}, pending);
        if (!updateData) {
          clearPending();
          return;
        }

        return fetch(config.cartUrl + '/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: updateData }),
          keepalive: true
        }).then(function () {
          // 書き込めてから捨てる。先に消すと、離脱で往復が切れたとき流入元が失われる
          clearPending();
        });
      })
      .catch(function () {})
      .then(function () { flushing = false; });
  }

  function start() {
    if (isBot()) return;
    var config = readConfig();
    if (!config) return;

    // cart:updated は Focal と c_common.js が documentElement まで bubbles させる
    document.documentElement.addEventListener('cart:updated', flush);

    if (config.cartUrl && location.pathname === config.cartUrl) flush();

    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () { capture(config); }, { timeout: 3000 });
    } else {
      setTimeout(function () { capture(config); }, 0);
    }
  }

  function boot() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  }

  if (document.prerendering) {
    document.addEventListener('prerenderingchange', boot, { once: true });
  } else {
    boot();
  }
})();
